module.exports = __webpack_public_path__ + "img/14.16ab43c0.jpg";